export default __webpack_public_path__ + "static/media/TitilliumWeb-SemiBold.d4d3eeb6.ttf";